module.exports = __webpack_public_path__ + "static/media/yellow-left-star-icon.4194fbe7.png";